export const isWindowsOs = () => {
  return getOs() === 'Windows';
};

export const isMobile = () => {
  return navigator.appVersion.indexOf('Mobile') >= 0;
};

export const getOs = () => {
  const os = ['Windows', 'Linux', 'Mac']; // add your OS values
  return os.find(v => navigator.appVersion.indexOf(v) >= 0);
};

export const isSmallThanWidth = width => {
  return window.innerWidth <= width;
};
